import { render, staticRenderFns } from "./Agreement.vue?vue&type=template&id=3bab8564&scoped=true&"
import script from "./Agreement.vue?vue&type=script&lang=js&"
export * from "./Agreement.vue?vue&type=script&lang=js&"
import style0 from "./Agreement.vue?vue&type=style&index=0&id=3bab8564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bab8564",
  null
  
)

export default component.exports